<template>
  <div class="background-color-seashell d-flex flex-1 px-3">
    <Nav :fix="fix" :navTabs="navTabs" />
  </div>
</template>

<script>
import Nav from "@/components/Navigation/Nav.vue";

export default {
  name: "Navigation",
  components: { Nav },
  props: { fix: Boolean, navTabs: Array },
};
</script>
